import { FC, PropsWithChildren } from "react"
import tw from "tailwind-styled-components"

export const MainWrapper = tw.div<{ $fullWidth?: boolean }>`
flex-grow
${(p) => (p.$fullWidth ? "" : "lg:p-8 p-2 md:p-4 pt-7")}
`

export const MainContent = tw.div<{ $fullWidth?: boolean }>`
${(p) => (p.$fullWidth ? "" : "m-auto")}
h-full
`

export const Main: FC<PropsWithChildren<{ fullWidth?: boolean; wrapperClassName?: string }>> = ({
  fullWidth,
  children,
  wrapperClassName = "",
}) => {
  return (
    <MainWrapper className={wrapperClassName} $fullWidth={fullWidth}>
      <MainContent $fullWidth={fullWidth}>{children}</MainContent>
    </MainWrapper>
  )
}
